import { render, staticRenderFns } from "./TotalBoardListArticle.vue?vue&type=template&id=7a68741c"
import script from "./TotalBoardListArticle.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardListArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports